{
    "navigation": {
        "energySupply": "Erzeugung",
        "generation": "Erzeugung",
        "supply": "Energieversorgung",
        "availability": "Verfügbarkeit",
        "financial": "Energiekosten",
        "demand": "Bedarf",
        "profile": "Profil",
        "settings": "Einstellungen",
        "adminDashboard": "Admin Dashboard",
        "portfolio": "Portfolio"
    },
    "dashboard": {
        "tabPanel": {
            "tabTitle": {
                "portfolios": "Portfolios",
                "sites": "Sites",
                "assets": "Assets",
                "dataPoints": "Data Points",
                "graphCollections": "Graph Collections",
                "userPermissions": "Nutzerrechte"
            },
            "table": {
                "name": "Name"
            }
        },
        "deleteConfirmation": {
            "deleteActionConfirmMessage": "Please confirm your action: Delete '{{data}}'."
        },
        "portfolio": {
            "deletePortfolioBtn": "Delete Portfolio"
        },
        "site": {
            "deleteSiteBtn": "Delete Site",
            "error": {
                "atLeastOneSiteRequired": "At least one site must be entered"
            },
            "info": {
                "multipleSiteInputInfo": "You can add multiple sites by entering one name at a time and pressing Enter."
            }
        },
        "asset": {
            "deleteAssetBtn": "Delete Asset"
        },
        "dataSeries": {
            "deleteDataSeriesBtn": "Delete Data Point"
        },
        "userPermissions": {
            "delete": "Nutzerrechte Löschen"
        },
        "createPortfolio": "Create Portfolio",
        "createSite": "Create Site",
        "createAsset": "Create Asset",
        "createDataPoint": "Create Data Point",
        "createGraphCollection": "Create Graph Collection",
        "createUserPermission": "Create User Permission"
    },
    "login": {
        "login": "Einloggen",
        "loginAuth0": "Anmelden",
        "loginText": "Bitte melden Sie sich mit ihrem Benutzer an (KID oder E-Mail).",
        "signUp": "Jetzt registrieren",
        "signUpText": "Noch kein Konto? "
    },
    "profile": {
        "tenant": "Mieter",
        "personal data": "Persönliche Daten",
        "language": "Sprache",
        "logout": "Abmelden"
    },
    "button": {
        "download": "Herunterladen",
        "uploadDemand": "Bedarf hochladen",
        "enterDowntime": "Stillstand anlegen",
        "reset": "Änderung löschen",
        "cancel": "Abbrechen",
        "save": "Speichern",
        "update": "Aktualisieren",
        "add": "Fertig",
        "addTimeSlot": "Neuer Eintrag"
    },
    "graphCollection": {
        "caption": {
            "graphExplanation": "Gestrichelt: Fahrplan, Durchgezogen: Messwert"
        }
    },
    "dialogScreen": {
        "asset": "Asset",
        "form": {
            "title": "Neuer Eintrag",
            "editTitle": "Anlage-aktualisierung",
            "updateTitle": "Anlage-Bearbeitung",
            "input": {
                "label": {
                    "type": "Typ",
                    "selectAsset": "Wähle eine Anlage",
                    "startDate": "Start",
                    "startTime": "Startzeit",
                    "endDate": "Ende",
                    "endTime": "Endzeitpunkt",
                    "minRestriction": "Min. Betriebspunkt",
                    "maxRestriction": "Max. Betriebspunkt"
                }
            },
            "assetSelectLabel": "Select an asset",
            "typeLabel": "Type"
        }
    },
    "heatMap": {
        "time": "Zeit",
        "total": "Gesamt"
    },
    "sitePortfolio": {
        "site": "Standort",
        "portfolio": "Portfolio"
    },
    "error": {
        "An unexpected error occurred. Please try again.": "An unexpected error occurred. Please try again.",
        "409": "Something went wrong, please reload the page and try again.",
        "400": "The request was invalid. Please check your input and try again."
    },
    "Power Generation": "Stromerzeugung",
    "Heat Generation": "Wärmeerzeugung",
    "Heat Consumption": "Wärmeverbrauch",
    "Cooling Generation": "Kälteerzeugung",
    "Gas": "Gas",
    "Thermal Storage": "Wärmespeicher",
    "Heat Supply": "Wärmeversorgung",
    "Power Supply": "Stromversorgung",
    "Planning": "Planung",
    "Power Cost": "Stromkosten",
    "Value Add": "Mehrwert",
    "Energy Cost": "Energiekosten",
    "Heat Demand": "Wärmebedarf",
    "Absorption Chiller": "AKM",
    "Ancillary Service": "Regelleistung",
    "CHP 1": "BHKW 1",
    "CHP 2": "BHKW 2",
    "Compressed Air": "DHKW",
    "Compressed Air High T": "DHKW HT",
    "Compressed Air Low T": "DHKW NT",
    "Cooling Demand -10°C": "Kältebedarf -10°C",
    "Cooling Generation -10°C": "Kälteerzeugung -10°C",
    "Emergency Cooling Compressed Air": "Notkühlung DHKW",
    "Emergency Cooling Low T": "Notkühlung DHKW",
    "Storage Fill Level": "Speicherfüllstand",
    "Power Demand": "Strombedarf",
    "Power Price DE": "Strompreis DE",
    "Gas Cost": "Gaskosten",
    "Total Energy Costs": "Energiekosten gesamt",
    "Value Added Through Optimization": "Mehrwert durch Optimierung",
    "Emergency Cooling CHP": "Emergency Cooling CHP",
    "available": "Verfügbar",
    "unavailable": "Nicht verfügbar",
    "unutilized": "Nicht in Betrieb",
    "limited": "Vorgabe",
    "AVAILABLE": "Verfügbar",
    "UNAVAILABLE": "Nicht verfügbar",
    "UNUTILIZED": "Nicht in Betrieb",
    "LIMITED": "Vorgabe",
    "lastUpdate": "Letzte Aktualisierung",
    "status": {
        "error": "Fehler",
        "success": "Erfolg"
    }
}
